import { FiFacebook, FiLinkedin, FiChevronRight, FiMapPin, FiPhone } from "react-icons/fi";

const HeaderTopBar = () => {
    return (
        <div className="header-top-bar">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-4 col-md-12 col-12 d-none d-lg-block">
                        <div className="header-left">
                            <p><a href="/">Get the most advanced electrical solutions<FiChevronRight /></a></p>
                        </div>
                    </div>
                    <div className="col-lg-8 col-md-12 col-12">
                        <div className="header-right d-flex align-items-center justify-content-end flex-nowrap">
                            <div className="address-content d-flex align-items-center flex-nowrap">
                                <p className="d-none d-md-block mb-0 me-3"><a href="https://www.google.com/maps/place/KR+Cable+Trays/@11.055376,76.975803,17z"
    target="_blank"
    rel="noopener noreferrer"
    className="d-flex align-items-center gap-1"><FiMapPin /><span>Coimbatore, Tamil Nadu, India</span></a></p>
                                <p className="mb-0 me-3 text-nowrap"><FiPhone /><span><a href="tel:+042225356222">+0422 253 5622</a></span></p>
                                <p className="mb-0 me-3 text-nowrap"><a href="mailto:info@krpower.in">📧 info@krpower.in</a></p>
                                <div className="social-icon-wrapper ms-2">
                                    <ul className="social-icon social-default icon-naked mb-0 d-flex align-items-center flex-row">
                                        <li className="mb-0"><a href="https://www.facebook.com/krcabletray/"><FiFacebook /></a></li>
                                        {/* <li><Link to="instagram.com"><FiInstagram /></Link></li> */}
                                        <li className="mb-0"><a href="https://www.linkedin.com/in/k-r-power-supports-private-limited-2072a6162/"><FiLinkedin /></a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default HeaderTopBar;
